import { useEffect, type RefObject } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reset scroll position on navigation by default —
// call this once per top-level layout so new pages always start at the top.
// Pass a ref when the layout scrolls an inner container instead of the window
// (e.g. a `overflow-y-auto` main panel), otherwise it scrolls the window.
export function useScrollToTop(containerRef?: RefObject<HTMLElement | null>) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, containerRef]);
}
